import { rootStateBranchSelector } from 'shared/utils/rootStateBranchSelector';

export const saveSearchSelector = rootStateBranchSelector('saveSearch');
